export const OPEN = "MENU.OPEN";
export const CLOSE = "MENU.CLOSE";
